<template>
    <div class="d-flex justify-content-center mb-3">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
</template>

<script>
export default {
    name: "SpinnerComponent"
}
</script>

<style scoped>

</style>
